'use strict';

exports.__esModule = true;

var _h = require('./h');

var _h2 = _interopRequireDefault(_h);

var _patch = require('./patch');

var _patch2 = _interopRequireDefault(_patch);

var _toHTML = require('./toHTML');

var _diff = require('./diff');

var _diff2 = _interopRequireDefault(_diff);

var _domApi = require('../cpp/domApi');

var _domApi2 = _interopRequireDefault(_domApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};

// import() is compiled to require.ensure, this is a polyfill for nodejs
// an alternative solution is needed
if (typeof require.ensure !== 'function') require.ensure = function (d, c) {
  c(require);
};

exports['default'] = function (config) {
  if (config === undefined) config = {};

  if (cache.lib !== undefined && config.hardReload !== true) {
    return Promise.resolve(cache.lib);
  }

  if (config.clearMemory === undefined) config.clearMemory = true;
  if (config.unsafePatch === undefined) config.unsafePatch = false;

  var result = void 0;
  var readyPromise = new Promise(function (resolve) {
    config['_main'] = function () {
      return resolve(cache);
    };
  });
  if ((config.useWasm === true || 'WebAssembly' in window) && config.useAsmJS !== true) {
    result = new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('./loadWasm'));
      });
    }).then(function (x) {
      return x['default'](config);
    });
  } else {
    result = new Promise(function (resolve) {
      require.ensure([], function (require) {
        resolve(require('../../compiled/asmjs/asm-dom.asm.js'));
      });
    });
  }

  return result.then(function (lib) {
    return lib(config);
  }).then(function (lib) {
    cache.lib = lib;

    if (window === undefined && global !== undefined) global.window = {};
    window.asmDom = lib;

    lib.h = _h2['default'];
    lib.patch = _patch2['default'];
    lib.toHTML = _toHTML.toHTML;
    lib.getNode = function (vnode) {
      return _domApi.nodes[lib._getNode(vnode)];
    };
    lib.deleteVNode = function (oldVnode) {
      window.asmDomHelpers.vnodesData[oldVnode] = undefined;
      lib._deleteVNode(oldVnode);
    };
    lib.reset = function () {
      window.asmDomHelpers = {
        currentNode: undefined,
        domApi: _domApi2['default'],
        vnodesData: {},
        diff: _diff2['default'],
        appendProps: _toHTML.appendProps,
        insertInnerHTML: _toHTML.insertInnerHTML
      };
    };

    lib.reset();

    return readyPromise;
  }).then(function (x) {
    return x.lib;
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/asm-dom/lib/js/index.js
// module id = 3
// module chunks = 2